import { ModifyQuoteInfomationPageFromType } from '@/quote/enums/quote';
import {
  QuoteStatus,
  apiPreLoadSignedDocument,
  transformDateStrToTimeString,
} from '@jove-frontend/uikit';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { QuoteCommonStore } from './types';

export const useQuoteCommonStore = create<QuoteCommonStore>()(
  immer((set, get) => ({
    state: {
      modifyPageFromType: ModifyQuoteInfomationPageFromType.NORMAL,
      modifyPageFromPathKey: '',
      loadingQuotePrice: false,
      quotePriceReferenceCount: 0,
    },
    actions: {
      // update from page type
      updateModifyPageFromType(
        type = ModifyQuoteInfomationPageFromType.NORMAL,
        editPageKey = ''
      ) {
        set((store) => {
          store.state.modifyPageFromType = type;
          store.state.modifyPageFromPathKey = editPageKey;
        });
      },
      // query quote price loading
      updateQuotePriceLoading(
        loading = false,
        config?: { resetCount?: boolean }
      ) {
        set((store) => {
          let count = get().state.quotePriceReferenceCount;
          if (config?.resetCount) {
            count = 0;
          } else {
            count = loading ? ++count : --count;
          }
          store.state.loadingQuotePrice = count > 0;
        });
      },
      async preloadSignDocuments(quoteId, config?: { status: QuoteStatus }) {
        // Temporary comments are not necessary. Once the business stabilizes later, the relevant code can be deleted
        // if (config?.status !== QuoteStatus.REFERRAL) {
        //   // Pre load the quote signed document
        //   await apiPreLoadSignedDocument({
        //     quoteId,
        //     date: transformDateStrToTimeString(new Date(), {
        //       format: 'MM/DD/YYYY',
        //     }),
        //   });
        // }
      },
    },
  }))
);
